import React from 'react';
import { motion } from 'framer-motion';
import { LEXCE_AVATAR } from '../../data/homeScreen';
interface VoiceListeningProps {
  utterance: string;
}
const BARS = [0.35, 0.7, 1, 0.55, 0.85, 0.4];
export function VoiceListening({
  utterance
}: VoiceListeningProps) {
  return <div className="flex flex-col items-center px-6 py-10 text-center" data-id="element-169" data-mp="39agqoqgarp5t">
      <motion.img src={LEXCE_AVATAR} alt="" animate={{
      y: [0, -6, 0]
    }} transition={{
      duration: 2.2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="h-20 w-20 rounded-full object-cover ring-4 ring-vin-mist" data-id="element-170" data-mp="399oylplws9ka" />
      <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.14em] text-vin-tertiary" data-id="element-171" data-mp="2lkme89zw42m3">Listening</p>

      <div className="mt-3 flex h-8 items-end gap-1.5" aria-hidden="true" data-id="element-172" data-mp="2ql0gtciq2kcq">
        {BARS.map((scale, index) => <motion.span key={index} className="w-1.5 rounded-full bg-vin-primary" style={{
        height: 28 * scale
      }} animate={{
        scaleY: [0.4, 1, 0.5]
      }} transition={{
        duration: 0.9,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: index * 0.09
      }} data-id="element-173" data-mp="u53sm5laj34" data-mpi={index} />)}
      </div>

      <p className="mt-5 max-w-[17rem] text-[15px] font-medium leading-6 text-vin-ink" data-id="element-174" data-mp="1jmaa38a7cfkz">“{utterance}”</p>
    </div>;
}